import DesligamentosView from "../../components/rh/DesligamentosView";

export default function DesligamentosRh() {
  return <DesligamentosView />;
}
